module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Andelfingen_COA-ed6d575e2de16a115898c0d8c2b9b79c.svg";